module.exports = __webpack_public_path__ + "static/img/concept.24bf6164.png";